import { Text } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { oneformBFFNdpsSend } from 'src/bff';
import { CarlineSelect, DetalleMotivo, Loading, MultipleCTASelection, TelefonoEmail } from 'src/components';
import { FormController, LayoutTemplate, useOneFormContext } from 'src/feature-app';
import { getParamsForm } from 'src/feature-app/get-params-form';
import { ConfirmacionLEM, ThanKYouLEM } from 'src/forms/LEM';
import { FormDataGroup, FormInfo, OneFormState, Steps } from 'src/types';
import { formDataBuilder } from '../format-fields';
import { LEMFormProps } from './LEMController';
import { checkIdLeadHasCarline, useInitializeForm } from './use-initialize-lem-form';
import { title } from 'process';

export function LEMNoContactadoForm(props: LEMFormProps) {
	const { dpsData, idLead, idPerson, installation, dealersInfo, handleError, presubmit, trackFormLoad } = props;
	const [presubmitSent, setPresubmitSent] = useState(false);
	const { initializeForm } = useOneFormContext();
	const store = useStore();
	const dispatch = useDispatch();

	const ctasHorarios = [
		{
			label: 'Mañana',
			value: 'Mañana',
		},
		{
			label: 'Tarde',
			value: 'Tarde',
		},
	];

	let index = 0;
	const stepsWithModel: Steps[] = [
		{
			title: (
				<>
					<Text bold>¿Por qué modelo </Text>contactaste con tu punto de venta?
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<div>
							<CarlineSelect useCarline={true} />
						</div>
					}
				/>
			),
			screenIndex: index++,
			name: 'Modelo',
		},
		/*{
      title: (
        <>
          Para averiguar qué ha pasado, necesitamos saber <Text bold>quién eres</Text>
        </>
      ),
      fields: (
        <LayoutTemplate
          element={
            <div>
              <NombreApellidos />
            </div>
          }
        />
      ),
      screenIndex: index++,
      name: 'NombreApellidos',
      outputs: ['name', 'surname', 'secondSurname'],
      outputsText: ['name', 'surname', 'secondSurname'],
    },*/
		{
			title: (
				<>
					¿Nos podrías confirmar tus <Text bold>datos de contacto?</Text>
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<TelefonoEmail requiredEmail requiredTelefono />
					}
				/>
			),
			screenIndex: index++,
			name: 'EmailTelefono',
			outputs: ['cellphone', 'email'],
			outputsText: ['cellphone', '/', 'email'],
		},
		{
			title: (
				<>
					<Text bold>¿En qué horario</Text> prefieres ser contactado?
				</>
			),
			fields: <LayoutTemplate element={<MultipleCTASelection ctaValues={ctasHorarios} name="horario" nextOnClick />} />,
			screenIndex: index++,
			name: 'Horario',
		},
		{
			title: (
				<>
					<Text bold>¿Quieres añadir </Text> algun comentario adicional?
				</>
			),
			fields: <LayoutTemplate element={<DetalleMotivo name="comentario" />} />,
			screenIndex: index++,
			name: 'Comentario',
		},
		{
			fields: <ConfirmacionLEM />,
			screenIndex: index++,
			name: 'Confirmacion',
		},
	];

	const LEMNoContactadoData: Partial<FormDataGroup> = {
		headers: {},
		fields: {
			name: idLead.FirstName,
			surname: idLead.LastName,
			secondSurname: idLead.MiddleName,
			email: idLead.Email,
			cellphone: idLead.MobilePhone,
			formName: 'lem-no_contactado',
			formType: 'otherform',
			pageCategory: 'Más Información',
		}, // Analítica
	};

	const generateData = (data?: Partial<FormDataGroup>) => {
		const { formData, dealersInfo }: OneFormState = store.getState();
		const { fields } = formData;
		const { tc, today, url, device } = getParamsForm();

		return {
			'headers[DPS_TOKEN]': 'VW_DDB_FRM_LEM_ENCUESTA',
			'headers[FK_SYSTEM]': idLead.Id,
			'headers[FORM_DATE_INSERTION]': today,
			'headers[FORM_DETAILS]': 'LEM No Contactado',
			'headers[FORM_NAME]': fields.formName ? `vw-oneform-${fields.formName}` : `vw-oneform-${data.fields.formName}`,
			'headers[FORM_OBJECTIVE]': 'Encuesta',
			'headers[FORM_URL]': url,
			'headers[FORM_VERSION]': fields.formName ? `vw-oneform-${fields.formName}-${process.env.VERSION}` : `vw-oneform-${data.fields.formName}-${process.env.VERSION}`,
			'headers[ORIGIN_DEVICE_TYPE]': device,
			'headers[ORIGIN_TRACKING_CODE]': tc,
			'headers[PINCODE]': dpsData.pincode.pincodeResponse.params.pincode,

			'flags[PERSON_RGPD_ADAPTED]': true,
			'flags[FLAG_RELACION_MARCA_SIN_IC]': false,

			'fields[DPS_BRAND]': 'Volkswagen',
			'fields[PERSON_EMAIL]': idLead.Email,
			'fields[PERSON_NAME]': fields.name ? fields.name : idLead.FirstName,
			'fields[PERSON_PHONE_MOBILE]': idLead.MobilePhone,
			'fields[PERSON_RGPD_COM_COMERCIALES]': fields.lssi ? fields.lssi : 'NO INFORMADO',
			'fields[PERSON_RGPD_PERFILADO]': fields.tmk ? fields.tmk : 'NO INFORMADO',
			'fields[PERSON_SURNAME_1]': fields.surname ? fields.surname : idLead.LastName,
			'fields[PERSON_SURNAME_2]': fields.secondSurname ? fields.secondSurname : idLead.MiddleName,
			'fields[SF_LEAD_INSTALLATION_ID]': idLead.Dealership__c,
			'fields[SF_LEAD_INSTALLATION_CODE]': installation ? installation.VGED_DealerCode__c : '',
			'fields[SF_LEAD_INSTALLATION_NAME]': installation ? installation.VGED_CommercialName__c : '',
			'fields[SURVEY_ANSWER_13]': fields.horario,
			'fields[SURVEY_ANSWER_14]': fields.comentario,
			'fields[VEH_INTEREST_NEW_OR_USED]': 'New Car',
			'fields[VEH_INTEREST_ID]': checkIdLeadHasCarline(idLead) && dealersInfo?.selectedCarline ? dealersInfo.selectedCarline.code : fields.carlineCode,
			'fields[VEH_INTEREST_MODEL]': checkIdLeadHasCarline(idLead) && dealersInfo?.selectedCarline ? dealersInfo.selectedCarline.title : fields.modelo,
		};
	};

	const generatePresubmitData = () => {
		const data = generateData(LEMNoContactadoData);

		data['headers[FORM_DETAILS]'] = 'LEM Pregrabación';
		data['headers[DPS_TOKEN]'] = 'VW_DDB_FRM_LEM_ENCUESTA_PREGRABACION';

		return data;
	};

	useEffect(() => {
		if (!presubmitSent && presubmit) sendForm(true);
	}, []);

	const sendForm = (isPresubmit?: boolean): Promise<boolean> => {
		return new Promise<any>(async (resolve, reject) => {
			const data = isPresubmit ? generatePresubmitData() : generateData();
			const dataStringified = JSON.stringify(data);
			const dataParsed = JSON.parse(dataStringified);
			const formData = formDataBuilder(dataParsed);
			const response = await oneformBFFNdpsSend(formData);

			if (response?.data?.status?.code == 200) {
				if (isPresubmit) setPresubmitSent(true);
				dispatch({ type: 'SET_FORM_RESPONSE', payload: response.data });
				resolve(true);
			} else {
				if (isPresubmit) handleError();
				resolve(false);
			}
		});
	};

	const { loading, steps, firstStep, lastStep } = useInitializeForm(stepsWithModel, idLead);

	useEffect(() => {
		const LEMNoContactadoInfo: Partial<FormInfo> = {
			formStarted: true,
			sendFormCallback: sendForm,
			fullScreen: firstStep.fullScreen ? true : false,
			lastStep,
			numberOfScreens: steps.length,
			screenIndex: firstStep.screenIndex,
			formTheme: 'main',
			notALayer: true,
			formType: 'inPage',
			step: firstStep,
			steps,
			stepsHistory: [0],
			thankYouComponent: <ThanKYouLEM />,
		};
		if (!loading) {
			initializeForm(LEMNoContactadoInfo, LEMNoContactadoData, true);
			trackFormLoad();
		}
	}, [loading]);

	return presubmitSent && steps ? <FormController steps={steps} screenType="full-screen" /> : <Loading />;
}
